export default {
  supplierNotFound: 'Mauvaise page!',
};